module.exports = __webpack_public_path__ + "files/6720479fa9c94c18f9f0862dee3540ba.png";